import React from "react";
import { Card, Row, Col } from "antd";
import { motion } from "framer-motion";
import styled from "styled-components";

const products = [
  { id: 1, title: "Product 1", image: "https://eyewear-workdo.myshopify.com/cdn/shop/products/5_c4998fc7-adc5-45b3-858f-273f158e0499_600x600.png?v=1671508344", },
  { id: 2, title: "Product 2", image:   "https://eyewear-workdo.myshopify.com/cdn/shop/products/15_c015f266-64b8-41bd-a383-bbe6dc66f53c_272x163.png?v=1671508382", },
  { id: 3, title: "Product 3", image:   "https://eyewear-workdo.myshopify.com/cdn/shop/products/5_c4998fc7-adc5-45b3-858f-273f158e0499_600x600.png?v=1671508344", },
  { id: 4, title: "Product 4", image:   "https://eyewear-workdo.myshopify.com/cdn/shop/products/1.png", },
  { id: 5, title: "Product 5", image:   "https://eyewear-workdo.myshopify.com/cdn/shop/products/5_c4998fc7-adc5-45b3-858f-273f158e0499_600x600.png?v=1671508344",},
  { id: 6, title: "Product 6", image: "https://eyewear-workdo.myshopify.com/cdn/shop/products/14_b88bf5a5-6819-440e-9a81-c2a81fc5386e_600x600.png?v=1671508367", },
];
  
const StyledCard = styled(motion(Card))`
  width: 100%;
  border-radius: 15px;
  height: 320px;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s;

  &:hover {
    transform: rotateY(10deg) scale(1.05);
  }
`;
const Container = styled.div`
  margin-top: 100px;
`;

const ProductPage = () => {
  return (
    <Container>
      <div style={{ padding: "20px" }}>
        <Row gutter={[16, 16]} justify="center">
          {products.map((product) => (
            <Col xs={24} sm={12} md={8} key={product.id}>
              <StyledCard
                hoverable
                cover={<img alt={product.title} src={product.image} />}
                initial={{ rotateY: 0 }}
                whileHover={{ rotateY: 15 }}
                transition={{ duration: 0.3 }}
              >
                <Card.Meta title={product.title} />
              </StyledCard>
            </Col>
          ))}
        </Row>
      </div>
    </Container>
  );
};

export default ProductPage;
